var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueTabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[(_vm.tab0Allowed)?_c('v-tab',{attrs:{"id":"tab0","title":_vm.$t('label.bridges')}},[_c('Bridges')],1):_vm._e(),(_vm.tab1Allowed)?_c('v-tab',{attrs:{"id":"tab1","title":_vm.$t('label.tunnels')}},[_c('Tunnels')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }